import { render } from "./ButtonGotoUp.vue?vue&type=template&id=e71cbf40&scoped=true"
import script from "./ButtonGotoUp.vue?vue&type=script&lang=js"
export * from "./ButtonGotoUp.vue?vue&type=script&lang=js"

import "./ButtonGotoUp.vue?vue&type=style&index=0&id=e71cbf40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e71cbf40"]])

export default __exports__